const TOGGLE_SELECTED = 'GOOGLE_PAY_TOGGLE_SELECTED';
const SET_READY = 'GOOGLE_PAY_SET_READY';
const SHOW_INLINE_ERROR = 'GOOGLE_PAY_SHOW_INLINE_ERROR';
const RESET_ERROR = 'GOOGLE_PAY_RESET_ERROR';

export {
    TOGGLE_SELECTED, SET_READY, SHOW_INLINE_ERROR, RESET_ERROR
};
